var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.642 21.395-.033-.033.016-.016-6.409-6.36a8.94 8.94 0 0 0-.758-11.854A9.08 9.08 0 0 0 9.05.5a9.07 9.07 0 0 0-6.392 2.632 8.92 8.92 0 0 0 0 12.704 9.07 9.07 0 0 0 6.392 2.632c1.895 0 3.79-.588 5.371-1.75l6.442 6.394.033.032a1.25 1.25 0 0 0 1.747 0c.477-.506.477-1.275 0-1.749M4.403 14.103c-1.236-1.243-1.928-2.878-1.928-4.627 0-1.75.692-3.384 1.928-4.61A6.58 6.58 0 0 1 9.05 2.951c1.763 0 3.41.687 4.646 1.913a6.48 6.48 0 0 1 1.928 4.611 6.4 6.4 0 0 1-1.367 3.99l-1.187 1.177A6.58 6.58 0 0 1 9.05 16a6.5 6.5 0 0 1-4.646-1.897"
  })));
};
export default SvgSearch;